import React from 'react'
import { useNavigate } from 'react-router-dom'
import utility from 'src/utils/utility'

import InstitutionList from '../InstitutionCreation/InstitutionList'

const InstitutionListPage = () => {
    const navigate = useNavigate()

    return (
        <InstitutionList
            onCreate={() =>
                navigate('/dashboardv2/institution-creation', {
                    state: { startInCreateMode: true },
                })
            }
        />
    )
}

export default utility.routeData(
    'institution-list',
    'Institution List',
    <InstitutionListPage />,
)